import React, { FC } from 'react';
import { StoreItemView, Toy } from '@specs/views';
import { useSession } from 'next-auth/react';
import { GoToToyButton } from '@components/Cards/ToyCard/Buttons/GoToToyButton';
import { SellToyButton } from '@components/Cards/ToyCard/Buttons/SellToyButton';
import { BuyToyButton } from '@components/Cards/ToyCard/Buttons/BuyToyButton';
import { EditToyButton } from '@components/Cards/ToyCard/Buttons/EditToyButton';
import { storeItem } from '@prisma/client';
interface Props {
  slug: Toy.Single['slug'];
  haveFigurinesForSale: boolean;
  firstStoreItem: StoreItemView | undefined;
  myFirstStoreItem: storeItem | undefined;
}
const isCorrectStoreItem = (storeItem: StoreItemView | undefined): storeItem is Omit<StoreItemView, 'instanceid'> & {
  instanceid: number;
} => typeof storeItem !== 'undefined' && typeof storeItem.instanceid === 'number';
export const ToyCardFooter: FC<Props> = ({
  slug,
  haveFigurinesForSale,
  firstStoreItem,
  myFirstStoreItem
}) => {
  const {
    status
  } = useSession();
  if (status === 'unauthenticated') return <GoToToyButton slug={slug} />;
  if (myFirstStoreItem) return <EditToyButton slug={slug} />;
  if (haveFigurinesForSale) return <SellToyButton slug={slug} />;
  if (isCorrectStoreItem(firstStoreItem)) return <BuyToyButton firstStoreItem={firstStoreItem} />;
  return <GoToToyButton slug={slug} data-sentry-element="GoToToyButton" data-sentry-component="ToyCardFooter" data-sentry-source-file="ToyCardFooter.tsx" />;
};